import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./gallery.css";
import Header from "components/Header";
import Footer from "components/Footer";
import Grid from "@mui/material/Unstable_Grid2";
import Horticultural from "assets/images/Horticultural.jpg";
import Gaol from "assets/images/gaol.jpg";
import OperaHarbour from "assets/images/opera-harbour.jpg";
import Singapore from "assets/images/singapore.jpg";
import Angkor from "assets/images/angkor.jpg";
import Flinder from "assets/images/flinder.jpg";
import Botany from "assets/images/botany.jpg";
import Floating from "assets/images/floating.jpg";
import Coogee from "assets/images/coogee.jpg";
import Seoul from "assets/images/seoul.jpg";
import Sky from "assets/images/sky.jpg";
import Circular from "assets/images/circular.jpg";
import Krivong from "assets/images/krivong.jpg";
import Cafe from "assets/images/cafe.jpg";
import Sunrise from "assets/images/sunrise.jpg";
import Beach from "assets/images/beach.jpg";
import Bombo from "assets/images/kiama.jpg";
import Parents from "assets/images/p.png";
import Partner from "assets/images/pa.png";

const IndividualImageComponent = ({ title, time, imageSrc, alt, id, note }) => {
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            observer.unobserve(img);
          }
        });
      },
      {
        rootMargin: "50px",
      },
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (
    <div className="individual-image-component" id={id}>
      <h3>{title}</h3>
      <p>{time}</p>
      <img
        ref={imageRef}
        data-src={imageSrc}
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" // Tiny transparent placeholder
        alt={alt}
        loading="lazy"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
      />
      {note && <p className="note">{note}</p>}
    </div>
  );
};

const Gallery = () => {
  const { t } = useTranslation();
  const images = [
    {
      titleKey: "parents",
      time: "April 2023",
      imageSrc: Parents,
      alt: "With my parents in Hunter Valley",
      hasNote: true,
    },
    {
      titleKey: "bombo",
      time: "10 December 2024",
      imageSrc: Bombo,
    },
    {
      titleKey: "partner",
      time: "April 2026",
      imageSrc: Partner,
      alt: "With my partner at a small restaurant in regional Kyoto",
      hasNote: true,
    },
    {
      titleKey: "horticultural",
      time: "21 February 2016",
      imageSrc: Horticultural,
      alt: "Horticultural Image",
    },
    {
      titleKey: "gaol",
      time: "19 December 2017",
      imageSrc: Gaol,
      alt: "Gaol Image",
    },
    {
      titleKey: "operaHarbour",
      time: "12 November 2017",
      imageSrc: OperaHarbour,
      id: "operaharbour",
      alt: "Sydney Opera House and Harbour Bridge",
    },
    {
      titleKey: "singapore",
      time: "16 December 2019",
      imageSrc: Singapore,
      alt: "Rain Vortex",
    },
    {
      titleKey: "angkor",
      time: "4 January 2020",
      imageSrc: Angkor,
      alt: "Angkor National Museum",
    },
    {
      titleKey: "flinder",
      time: "17 December 2017",
      imageSrc: Flinder,
      id: "operaharbour",
      alt: "Flinders St Station",
    },
    {
      titleKey: "botany",
      time: "1 January 2021",
      imageSrc: Botany,
      id: "botany",
      alt: "Kamay Botany Bay National Park",
    },
    {
      titleKey: "floating",
      time: "4 January 2020",
      imageSrc: Floating,
      alt: "The Floating Village",
    },
    {
      titleKey: "seoul",
      time: "5 October 2017",
      imageSrc: Seoul,
      alt: "Seoul to Sydney Flight",
    },
    {
      titleKey: "coogee",
      time: "29 October 2017",
      imageSrc: Coogee,
      alt: "Coogee Beach",
    },
    {
      titleKey: "sky",
      time: "29 January 2018",
      imageSrc: Sky,
      alt: "Sky in Sydney",
    },
    {
      titleKey: "circular",
      time: "12 November 2017",
      imageSrc: Circular,
      id: "operaharbour",
      alt: "Circular Quay",
    },
    {
      titleKey: "krivong",
      time: "27 December 2019",
      imageSrc: Krivong,
      alt: "Krivong Border City",
    },
    {
      titleKey: "cafe",
      time: "13 August 2017",
      imageSrc: Cafe,
      id: "operaharbour",
      alt: "A Cafe in Xi'an",
    },
    {
      titleKey: "sunrise",
      time: "28 December 2019",
      imageSrc: Sunrise,
      alt: "Sunrise in Sihanoukville",
    },
    {
      titleKey: "beach",
      time: "25 November 2023",
      imageSrc: Beach,
    },
  ];

  return (
    <>
      <Header />
      <div className="gallery">
        {images.map((image, index) => (
          <IndividualImageComponent
            key={index}
            title={t(`gallery.images.${image.titleKey}.title`)}
            time={image.time}
            imageSrc={image.imageSrc}
            alt={image.alt}
            id={image.id}
            note={
              image.hasNote
                ? t(`gallery.images.${image.titleKey}.note`)
                : undefined
            }
          />
        ))}
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
